import { useAppStore } from '@core/store'
import PainelDeEstilosDeCorte from './PainelDeEstilosDeCorte'

/** "Preenchimento a cheio": o mesmo interruptor na caixa de corte e nos
 *  planos, porque o preenchimento é de todos os cortes (Rui, 18/10/2026:
 *  "o preenchimento não se aplica apenas aos planos de corte").
 *
 *  Diz também quantos elementos ficaram cheios e quantos ficaram de
 *  fora por o contorno não fechar, para ninguém pensar que é defeito do
 *  corte quando é a geometria do elemento. */
export default function InterruptorDoPreenchimento() {
  const ligado = useAppStore((s) => s.preenchimentoDeCorte)
  const setLigado = useAppStore((s) => s.setPreenchimentoDeCorte)
  const info = useAppStore((s) => s.preenchimentoInfo)

  let estado: string | null = null
  if (ligado && info) {
    if (info.aCalcular) estado = 'a calcular…'
    else if (info.elementos > 0 || info.abertos > 0) {
      estado = `${info.elementos} ${info.elementos === 1 ? 'elemento' : 'elementos'}`
      if (info.abertos > 0) {
        estado += `; ${info.abertos} sem preenchimento (contorno aberto)`
      }
    }
  }

  return (
    <>
      <label
        className="mb-2 flex cursor-pointer flex-wrap items-center gap-1.5 text-[10px] text-[var(--color-text-muted)]"
        title="Preencher a cheio a secção dos elementos cortados, pela caixa e pelos planos. Cada elemento é tratado sozinho, por isso um elemento isolado também fica cheio. Um elemento cuja malha não fecha fica só com as faces."
        data-campo="preenchimento-de-corte"
      >
        <input
          type="checkbox"
          checked={ligado}
          onChange={(e) => setLigado(e.target.checked)}
          className="accent-[var(--color-accent)]"
        />
        Preenchimento a cheio
        {estado && <span className="text-[var(--color-text-dim)]">({estado})</span>}
      </label>
      {ligado && <PainelDeEstilosDeCorte />}
    </>
  )
}
